import { useQuery } from '@tanstack/react-query'
import {
  fetchDashboard,
  fetchNewUsersChart,
  fetchNewOrdersChart,
  fetchRevenueChart,
  fetchOrderStatusChart
} from '@/lib/api'

export const useDashboard = () => {
  return useQuery({
    queryKey: ['dashboard'],
    queryFn: fetchDashboard,
    staleTime: 0,
    gcTime: 10 * 60 * 1000,
    refetchOnMount: 'always',
    refetchInterval: 60 * 1000
  })
}

const chartQueryOptions = {
  staleTime: 5 * 60 * 1000,
  retry: false,
  refetchInterval: 60 * 1000
}

export const useNewUsersChart = (range: string, enabled = true) =>
  useQuery({
    ...chartQueryOptions,
    enabled,
    queryKey: ['dashboard-charts', 'new-users', range],
    queryFn: () => fetchNewUsersChart(range)
  })

export const useNewOrdersChart = (range: string, enabled = true) =>
  useQuery({
    ...chartQueryOptions,
    enabled,
    queryKey: ['dashboard-charts', 'new-orders', range],
    queryFn: () => fetchNewOrdersChart(range)
  })

export const useRevenueChart = (range: string, enabled = true) =>
  useQuery({
    ...chartQueryOptions,
    enabled,
    queryKey: ['dashboard-charts', 'revenue', range],
    queryFn: () => fetchRevenueChart(range)
  })

export const useOrderStatusChart = (range: string, enabled = true) =>
  useQuery({
    ...chartQueryOptions,
    enabled,
    queryKey: ['dashboard-charts', 'order-status', range],
    queryFn: () => fetchOrderStatusChart(range)
  })
